module.exports = __webpack_public_path__ + "img/xpay.5164d4d2.svg";